/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXUpIcon20Solid = forwardRef('DataChartBarsXUpIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M16 2.5a1 1 0 0 1 1 1v10.719a1 1 0 0 1-2 0V3.5a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M13 6a1 1 0 1 0-2 0v8.219a1 1 0 0 0 2 0V6Z" }),
        React.createElement("path", { d: "M4 9.75a1 1 0 0 1 1 1v3.5a1 1 0 1 1-2 0v-3.5a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M1 18a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M9 8.35a1 1 0 0 0-2 0v5.869a1 1 0 0 0 2 0V8.35Z" })));
});
